import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SearchParams, SearchSort, SearchType } from "@/entry/local/movie";
import { SearchResult } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import { videoRepo } from "@/repo/video-repo";
import Header from "@/component/header";
import Footer from "@/component/footer";
import MoviesGrid from "@/component/commom/movies-grid";
import { useQueryParams, getQueryParam } from "@/hooks/useQueryParams";

export default function SearchPage() {
    const queryParams = useQueryParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [searchResult, setSearchResult] = useState<SearchResult | null>(null);
    const [pagination, setPagination] = useState<Pagination | null>(null);
    const [searchParamsObject, setSearchParamsObject] = useState<SearchParams | null>(null);
    const [pageTitle, setPageTitle] = useState("");

    useEffect(function () {
        setLoading(true);
        var s = getQueryParam(queryParams, "s", "");
        var type = getQueryParam(queryParams, "type", "");
        var imdbRate = getQueryParam(queryParams, "imdb_rate", "0");
        var ageRating = getQueryParam(queryParams, "age_rating", "");
        var isDubbed = getQueryParam(queryParams, "is_dubbed", "");
        var isSubbed = getQueryParam(queryParams, "is_subbed", "");
        var startYear = getQueryParam(queryParams, "start_year", "0");
        var endYear = getQueryParam(queryParams, "end_year", "0");
        var status = getQueryParam(queryParams, "status", "");
        var genre = getQueryParam(queryParams, "genre", "0");
        var country = getQueryParam(queryParams, "country", "");
        var language = getQueryParam(queryParams, "language", "");
        var network = getQueryParam(queryParams, "network", "");
        var director = getQueryParam(queryParams, "director", "");
        var actor = getQueryParam(queryParams, "actor", "");
        var sort = getQueryParam(queryParams, "sort", "");
        var page = getQueryParam(queryParams, "page", "1");
        var title = getQueryParam(queryParams, "title", "");

        var paramsObject: SearchParams = {
            s: s,
            type: type as SearchType,
            imdb_rate: parseFloat(imdbRate),
            age_rating: ageRating,
            is_dubbed: isDubbed === "true",
            is_subbed: isSubbed === "true",
            start_year: parseInt(startYear, 10),
            end_year: parseInt(endYear, 10),
            status: status,
            genre: parseInt(genre, 10),
            country: parseInt(country, 10),
            language: parseInt(language, 10),
            network: parseInt(network, 10),
            director: director,
            actor: actor,
            sort: sort as SearchSort,
            page: parseInt(page, 10),
        };

        videoRepo.search(paramsObject).then(function (result) {
            var resolvedTitle = title;
            if (!resolvedTitle) {
                var searchText = paramsObject.s;
                if (!searchText) {
                    searchText = "جستجوی خالی";
                }
                resolvedTitle = "نتایج جستجو برای " + searchText;
            }
            if (result.data) {
                setSearchResult(result.data);
            }
            if (result.pagination) {
                setPagination(result.pagination);
            }
            setSearchParamsObject(paramsObject);
            setPageTitle(resolvedTitle);
            setLoading(false);
        });
    }, [location.search]);

    if (loading || !searchResult || !pagination || !searchParamsObject) {
        return (
            <div className="page-loading">
                <div className="loader" />
            </div>
        );
    }

    return (
        <>
            <Header />
            <MoviesGrid
                defaultSearchResult={searchResult}
                defaultPagination={pagination}
                title={pageTitle}
                defaultSearchParams={searchParamsObject}
                allowType={true}
                allowGenre={true}
                allowSort={true}
                allowImdbRating={true}
                allowDubbed={true}
                allowSubtitled={true} />
            <Footer />
        </>
    );
}
